module.exports = __webpack_public_path__ + "img/logo27.63067fa1.png";